import '../scss/wall-of-fame.scss';
import $ from 'jquery';

$(document).ready(function() {
  let position = 0;
  let paperFrameContentHeight = $('div.paper-frame > div').height();

  if( $('.content-main-right').height() <= paperFrameContentHeight ) {
    $('div.paper-frame').css( 'height', paperFrameContentHeight );
  }

  /**
   * Click action to show submenu for each letter in separate list
   *
   * 1. Stop the default link action
   * 2. Prevent event bubbling
   * 3. Hide the list
   * 4. Scroll the new list down
   */
  $('div.page-char-menu > ul > li > a').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    $('div.page-char-menu ul').find('li a').not($(this)).removeClass('active');
    $('dl.portraits-menu-sub').hide();

    let $msg = $(this).addClass('active').parent().next('dl').html();
    if( $msg ) {
      $('dl.portraits-menu-sub').html($msg).slideDown();
    }

    /**
     * Click action to show the subtitle for each item in list
     *
     * 1. Stop default link action
     * 2. Prevent event bubbling
     */
    $('dl.portraits-menu-sub div').each( function() {
      $(this).on('click', function(e) {
        if( $(this).hasClass('prevented') ) {
          e.preventDefault();
          e.stopPropagation();
        }

        $(this).parent().find('div').not($(this)).removeClass('active').addClass('prevented')
          .children('dd').removeClass('active').slideUp(500);

        $(this).removeClass('prevented').addClass('active').children('dd').addClass('active').slideDown(600);
      });
    });
  });


  if( $('div.content-text-wrap > div').height() > $('div.content-text').height() ) {
    /**
     * Click action to scroll through text
     */
    $('section.wof-detail button.scrollbar-btn').on('click', function() {
      if ($(this).hasClass('up')) {
        if( position > 0 ) {
          position = position - 300;
        }
        $('div.content-text-wrap').animate({ scrollTop: position });
      }
      else if( $(this).hasClass('down') ) {
        if( position < $('div.content-text-wrap').children().height() ) {
          position = position + 300;
        }
        $('div.content-text-wrap').animate({ scrollTop: position });
      }

    });

    $('div.content-text-wrap').on('scroll', function() {
      position = $(this).scrollTop();
    });
  } else {
    $('section.wof-detail .scrollbar').css('display', 'none');
  }
});
